var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 217,
    viewBox: "0 0 394 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_7756)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 393.33,
    height: 216.646,
    fill: "url(#paint0_radial_4130_7756)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4130_7756)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4130_7756)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 195.69,
    cy: 107.88,
    r: 49.5191,
    fill: "url(#paint1_linear_4130_7756)",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 195.69,
    cy: 107.88,
    r: 54.8247,
    stroke: "white",
    strokeWidth: 10.6112
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4130_7756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.098 126.016H198.94M199.824 114.215C204.006 112.229 206.897 107.966 206.897 103.028C206.897 96.1922 201.355 90.6504 194.519 90.6504C187.683 90.6504 182.141 96.1922 182.141 103.028C182.141 107.966 185.032 112.229 189.214 114.215V115.406C189.214 117.054 189.214 117.878 189.483 118.528C189.842 119.395 190.531 120.083 191.397 120.442C192.047 120.711 192.871 120.711 194.519 120.711C196.167 120.711 196.991 120.711 197.641 120.442C198.507 120.083 199.196 119.395 199.555 118.528C199.824 117.878 199.824 117.054 199.824 115.406V114.215Z",
    stroke: "url(#paint2_linear_4130_7756)",
    strokeWidth: 3.53708,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 73.2709,
    y: -61.8983,
    width: 291.317,
    height: 338.675
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(8.84px)",
      clipPath: "url(#bgblur_1_4130_7756_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4130_7756)",
    "data-figma-bg-blur-radius": 17.6854
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0181 209.672C90.2555 212.434 90.2449 216.927 93.1333 219.558C113.496 238.105 138.563 250.787 165.664 256.178C195.082 262.029 225.574 259.026 253.285 247.548C280.996 236.07 304.681 216.632 321.344 191.693C338.008 166.754 346.902 137.434 346.902 107.44C346.902 77.4457 338.008 48.1253 321.344 23.1862C304.681 -1.75283 280.996 -21.1905 253.285 -32.6687C225.574 -44.1468 195.082 -47.1501 165.664 -41.2985C138.563 -35.9078 113.496 -23.2252 93.1332 -4.67866C90.2448 -2.04783 90.2554 2.44497 93.0181 5.20762L133.157 45.3462C135.919 48.1089 140.38 48.0818 143.374 45.5715C153.74 36.8794 166.157 30.9058 179.499 28.2518C195.161 25.1365 211.395 26.7354 226.148 32.8464C240.901 38.9573 253.511 49.3059 262.382 62.5834C271.254 75.8608 275.989 91.4709 275.989 107.44C275.989 123.408 271.254 139.018 262.382 152.296C253.511 165.573 240.901 175.922 226.148 182.033C211.395 188.144 195.161 189.743 179.499 186.628C166.157 183.974 153.74 178 143.374 169.308C140.38 166.798 135.919 166.77 133.157 169.533L93.0181 209.672Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4130_7756",
    x: 135.56,
    y: 47.75,
    width: 120.261,
    height: 120.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.53708
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420627 0 0 0 0 0.0121568 0 0 0 0 0.595686 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7756"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4130_7756",
    x: 135.56,
    y: 47.75,
    width: 120.261,
    height: 120.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.00784314 0 0 0 0 0.478431 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7756"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4130_7756",
    x: 180.373,
    y: 88.8828,
    width: 28.293,
    height: 39.9635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.06112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.530562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7756"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4130_7756",
    x: 73.2709,
    y: -61.8983,
    width: 291.317,
    height: 338.675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.53708
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76854
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4130_7756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4130_7756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4130_7756_clip_path",
    transform: "translate(-73.2709 61.8983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0181 209.672C90.2555 212.434 90.2449 216.927 93.1333 219.558C113.496 238.105 138.563 250.787 165.664 256.178C195.082 262.029 225.574 259.026 253.285 247.548C280.996 236.07 304.681 216.632 321.344 191.693C338.008 166.754 346.902 137.434 346.902 107.44C346.902 77.4457 338.008 48.1253 321.344 23.1862C304.681 -1.75283 280.996 -21.1905 253.285 -32.6687C225.574 -44.1468 195.082 -47.1501 165.664 -41.2985C138.563 -35.9078 113.496 -23.2252 93.1332 -4.67866C90.2448 -2.04783 90.2554 2.44497 93.0181 5.20762L133.157 45.3462C135.919 48.1089 140.38 48.0818 143.374 45.5715C153.74 36.8794 166.157 30.9058 179.499 28.2518C195.161 25.1365 211.395 26.7354 226.148 32.8464C240.901 38.9573 253.511 49.3059 262.382 62.5834C271.254 75.8608 275.989 91.4709 275.989 107.44C275.989 123.408 271.254 139.018 262.382 152.296C253.511 165.573 240.901 175.922 226.148 182.033C211.395 188.144 195.161 189.743 179.499 186.628C166.157 183.974 153.74 178 143.374 169.308C140.38 166.798 135.919 166.77 133.157 169.533L93.0181 209.672Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4130_7756",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.665 108.323) rotate(90) scale(129.545 235.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4130_7756",
    x1: 195.69,
    y1: 58.3613,
    x2: 195.69,
    y2: 157.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D12B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44027A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4130_7756",
    x1: 181.625,
    y1: 100.229,
    x2: 214.973,
    y2: 123.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7009F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F08B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_7756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393.33,
    height: 216.646,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryCompany);
export default __webpack_public_path__ + "static/media/library-company.3f209adfe44a857a2ffd02397d41071c.svg";
export { ForwardRef as ReactComponent };